import {ajax} from '../utils/ajaxHelper';

const baseUrl = '/pdp/recommendedProperties?source=PDP_IMP&fallback=false&details=true&size=20&';

const getByOwnerPropertiesUrl = function({listingId, site, startDate, endDate}) {
    let url = `${baseUrl}listingId=${listingId}`;
    url = site ? `${url}&site=${site}` : url;
    url = startDate ? `${url}&startDate=${startDate}` : url;
    url = endDate ? `${url}&endDate=${endDate}` : url;

    return url;
};

const getByOwnerProperties = (props) => {
    return ajax(getByOwnerPropertiesUrl(props));
};

export default getByOwnerProperties;
export {getByOwnerProperties, getByOwnerPropertiesUrl, baseUrl};
